import apiOg from "api/services/api-og-internal";
import { CartDispensary } from "custom-types/CartDispensary";
import logError from "utils/logError";

const protectedSettings = [
  "menuIntegrationPartnerSettings",
  "printNodeChildAccountPassword",
  "paymentProviderSettings",
  "orderIntegrationSettings",
];
// * This API should only ever be invoked via SSR due to its usage of an internal API key.
export const getCartDispensary = async (
  dispensaryId: number,
): Promise<CartDispensary | null> => {
  let dispensary: CartDispensary;

  try {
    const dispensaryResponse = await apiOg.get(
      `/v1/internal/dispensaries/${dispensaryId}`,
    );

    dispensary = dispensaryResponse?.data?.dispensary;

    if (!dispensary) {
      return null;
    }
  } catch (e) {
    logError(e.message, {
      functionName: "getCartDispensary",
      service: "apiog",
      statusCode: e.statusCode,
    });
    return null;
  }

  try {
    const partnerIntegrationsResponse = await apiOg.get(
      `/v2/internal/dispensary/${dispensaryId}/partner_integration?integrationType=menu_pull`,
    );

    const partnerIntegration =
      partnerIntegrationsResponse?.data?.partnerIntegrations[0];

    dispensary.isJaneRetailer =
      partnerIntegration?.partnerSlug === "i-heart-jane";
  } catch (e) {
    logError(e.message, {
      functionName: "getCartDispensary",
      service: "apiog",
      statusCode: e.statusCode,
    });
  }

  if (dispensary.onlinePaymentsAccepted) {
    try {
      const publicEncryptionKeyResponse = await apiOg.get(
        `/v1/internal/dispensaries/${dispensaryId}/payment_provider_settings/public_encryption_key`,
      );

      const publicEncryptionKey =
        publicEncryptionKeyResponse?.data?.publicEncryptionKey;

      if (!publicEncryptionKey) {
        logError(
          `No public encryption key set for dispensary (${dispensaryId})! This should be an impossible state`,
        );

        // Default to test key
        dispensary.publicEncryptionKey =
          "2d2d2d2d2d424547494e205055424c4943204b45592d2d2d2d2d4d494942496a414e42676b71686b6947397730424151454641414f43415138414d49494243674b434151454134553151745246744231756e715246597a635944692f35326d467977627663315941676a764b71447a684c597177513351707671614b794467636f346f6b4e427356683166467243476d50726f71666e562b78416f6e53342b46707659564e77562f715656712f6867656652776b5273444c4741725361366a6b7444384f757550794144504a715a356d56757536476f54764b4964565267493854347030725533594d324934585a7174663874524d7a6153362b743743362b575a3738356f396766654f2b6e2b754a2f547a657959534d4d736b65564a346e5553725a507936774439497739754b5870576b4a6331737a6351536f44536d577653736c305948786c485a3577416b4b635974597779576e636e6f5136484a68614536517239416348515948506b5544653865714a78754259636570356b49654c4865686d317473505443304f32386a556b75376c6946554a70576d774944415141422d2d2d2d2d454e44205055424c4943204b45592d2d2d2d2d";
      } else {
        dispensary.publicEncryptionKey = publicEncryptionKey;
      }
    } catch (e) {
      logError(e.message, {
        functionName: "getCartDispensary.getPublicEncryptonKey",
        service: "apiog",
        statusCode: e.statusCode,
      });
    }
  }

  protectedSettings.forEach(
    (field) => delete dispensary[field as keyof CartDispensary],
  );

  return dispensary;
};
